import { SIDEBAR } from '../actions/types';
import { limpiarFiltros } from "./generalActios";
import { setFiltroGrupoPlanes, setPlanesDesdeBusqueda, resetGrupoPlanes } from '../actions/planesActions';
import { setTiposGrupoPlanes, setFiltroTipoPublicaciones, resetTipoPublicaciones } from '../actions/tiposPublicacionActions';
import { resetPublicaciones, seModificaronImagenes, setFiltroPublicacion, resetListPublicaciones } from '../actions/publicacionesActions';
import { resetSellers, setFiltroSeller } from './sellersActions';
import { resetFiltroLiquidaciones } from './LiquidacionesActions';
import { setFiltroOrdenes, resetOrdenes } from '../actions/ordenesActions';
import { resetFiltroUsuario, resetFiltroUsuarios, resetListUsuarios, setFiltroUsuarios } from './usuariosActions';
import { resetRebates } from './rebatesActions';

const cloneItemsWithoutHiddenFlag = (items = []) =>
  items.map((item) => {
    const cloned = { ...item };
    delete cloned.isHidden;
    if (item.childItems?.length) {
      cloned.childItems = cloneItemsWithoutHiddenFlag(item.childItems);
    }
    return cloned;
  });

export const getSidebarItems = (userType = {}, idSeller, idUser, options = {}) => {
  const {
    isCategory,
    isAdminMod,
    isSellerAdmin,
    isSeller,
    isResetPassword,
    isSoloLectura,
    isProveedor,
    isContaduria,
    isTesoreria,
  } = userType;
  const forPermissions = options?.forPermissions === true;

  if (!forPermissions && isResetPassword) return [];

  const canSeeLiquidaciones = isCategory || isAdminMod;

  /* Si el usuario es Proveedor, solo puede ver "Gestión de Ordenes Proveedores" */
  if (!forPermissions && isProveedor) {
    return [
      {
        id: 42,
        icon: "sl-icon-basket",
        label: "Gestión de Ordenes Proveedores",
        goToPath: "/OrdenesProveedores"
      }
    ];
  }

  /* obtener iconos desde pictogrammers.github.io/@mdi/font/2.0.46/ || simplelineicons.github.io/ */
  const sidebarItems = [
    {
      id: 10,
      icon: "sl-icon-people",
      label: "Sellers",
      isHidden: (isSoloLectura || isProveedor),
      childItems: [
        {
          id: 11,
          icon: "sl-icon-people",
          label: (isSellerAdmin || isSeller) ? "Gestión de Seller" : "Gestión de Sellers",
          isHidden: (isSoloLectura || isProveedor || isTesoreria),
          goToPath: (isSellerAdmin || isSeller) ? "/Sellers/Editar/" + idSeller : "/Sellers"
        },
        {
          id: 12,
          icon: "sl-icon-wallet",
          label: "Gestión Datos Bancarios",
          isHidden: (!isCategory && !isAdminMod && !isTesoreria),
          goToPath: "/Sellers/GestionDatosBancarios"
        },
        {
          id: 13,
          icon: "sl-icon-docs",
          label: "Auditoría",
          isHidden: (!isCategory && !isAdminMod),
          goToPath: "/Sellers/Auditoria"
        },
      ]
    },
    //{
    //  id: 20,
    //  icon: "sl-icon-people",
    //  label: (!isAdminMod && !isSellerAdmin) ? "Gestión de Usuario" : "Gestión de Usuarios",
    //  isHidden: (isSoloLectura || isProveedor || isTesoreria),
    //  goToPath: (!isAdminMod && !isSellerAdmin) ? "/Usuarios/Editar/" + idUser : "/Usuarios"
    //},
    {
      id: 20,
      //icon: "sl-icon-people",
      icon: "sl-icon-user-following",
      label: "Usuarios",
      isHidden: (isSoloLectura || isProveedor || isTesoreria),
      childItems: [
        {
          id: 21,
          icon: "sl-icon-people",
          label: (!isAdminMod && !isSellerAdmin && !isCategory) ? "Gestión de Usuario" : "Gestión de Usuarios",
          isHidden: (isSoloLectura || isProveedor || isTesoreria),
          goToPath: (!isAdminMod && !isSellerAdmin && !isCategory) ? "/Usuarios/Editar/" + idUser : "/Usuarios"
        },

        //COMENTADO por ticket 2025111402
        //{
        //    id: 22,
        //    icon: "sl-icon-user",
        //    label: "Gestión Tipo Usuarios",
        //    isHidden: (isSoloLectura || isProveedor || isTesoreria || isSellerAdmin || isSeller),
        //    goToPath: "/Usuarios/TipoUsuarios"
        //},
      ]
    },
    // Oculto en esta rama: el ABM de Integradores queda en el código, sin menú.
    //{
    //  id: 65,
    //  icon: "sl-icon-layers",
    //  label: "Integradores",
    //  isHidden: (!isCategory && !isAdminMod),
    //  childItems: [
    //    {
    //      id: 66,
    //      icon: "sl-icon-layers",
    //      label: "Gestión de Integradores",
    //      goToPath: "/Integradores"
    //    },
    //    {
    //      id: 67,
    //      icon: "sl-icon-docs",
    //      label: "Auditoría",
    //      goToPath: "/Integradores/Auditoria"
    //    }
    //  ]
    //},
    {
      id: 30,
      icon: "mdi mdi-tag-multiple",
      label: "Publicaciones",
      isHidden: (isSoloLectura || isProveedor || isTesoreria),
      childItems: [
        {
          id: 31,
          icon: "mdi mdi-tag-multiple",
          label: "Gestión de Publicaciones",
          goToPath: "/Publicaciones"
        },
        {
          id: 32,
          icon: "mdi mdi-table-large",
          label: "Creacion Masiva",
          goToPath: "/Publicaciones/CreacionMasiva"
        },
        {
          id: 33,
          icon: "mdi mdi-table-large",
          label: "Actualización Masiva",
          goToPath: "/Publicaciones/ActualizacionMasiva"
        },
        {
          id: 34,
          icon: "mdi mdi-calendar-clock",
          label: "Fechas de Creación",
          isHidden: (!isCategory && !isAdminMod),
          goToPath: "/Publicaciones/FechasCreacion"
        },
      ]
    },
    //{
    //  id: 40,
    //  icon: "sl-icon-basket",
    //  label: "Gestión de Ordenes",
    //  isHidden: isTesoreria,
    //  childItems: [
    //    {
    //      id: 41,
    //      icon: "sl-icon-basket",
    //      label: "Ordenes Sellers",
    //      isHidden: isProveedor,
    //      goToPath: "/Ordenes"
    //    },
    //    {
    //      id: 42,
    //      icon: "sl-icon-basket",
    //      label: "Ordenes Proveedores",
    //      isHidden: (isSellerAdmin || isSeller || isSoloLectura),
    //      goToPath: "/OrdenesProveedores"
    //    }
    //  ]
    //},
    {
      id: 40,
      icon: "sl-icon-basket",
      label: "Órdenes",
      isHidden: isTesoreria,
      childItems: [
        {
          id: 41,
          icon: "sl-icon-basket",
          label: "Gestión de Ordenes Sellers",
          isHidden: isProveedor,
          goToPath: "/Ordenes"
        },
        {
          id: 42,
          icon: "sl-icon-basket",
          label: "Gestión de Ordenes Proveedores",
          isHidden: (isSellerAdmin || isSeller || isSoloLectura),
          goToPath: "/OrdenesProveedores"
        }
      ]
    },
    //{
    //  id: 50,
    //  icon: "mdi mdi-square-inc-cash",
    //  label: "Gestión de Rebates",
    //  isHidden: (isSoloLectura || isSeller || isProveedor || isTesoreria),
    //  goToPath: "/Rebates"
    //},
    {
      id: 130,
      icon: "mdi mdi-ticket-percent",
      label: "Cupones",
      isHidden: (!isCategory && !isAdminMod && !isSellerAdmin && !isSeller),
      goToPath: "/Cupones"
    },
    {
      id: 50,
      icon: "mdi mdi-square-inc-cash",
      label: "Rebates",
      isHidden: (isSoloLectura || isSeller || isProveedor || isTesoreria),
      childItems: [
        {
          id: 51,
          icon: "mdi mdi-square-inc-cash",
          label: "Gestión de Rebates",
          isHidden: (isSoloLectura || isSeller || isProveedor || isTesoreria),
          goToPath: "/Rebates"
        },
      ]
    },
    {
      id: 60,
      icon: "sl-icon-credit-card",
      label: "Grupo Planes",
      isHidden: (!isCategory && !isAdminMod),
      goToPath: "/Planes",
    },
    {
      id: 70,
      icon: "sl-icon-bag",
      label: "Tipo de publicaciones",
      isHidden: (!isCategory && !isAdminMod),
      childItems: [
        {
          id: 71,
          icon: "sl-icon-bag",
          label: "Gestión de Tipo de Publicaciones",
          goToPath: "/Tipo/Publicaciones"
        },
        {
          id: 72,
          icon: "sl-icon-docs",
          label: "Auditoría",
          goToPath: "/Tipo/Publicaciones/Auditoria"
        }
      ]
    },
    {
      id: 80,
      icon: "mdi mdi-file-excel",
      label: "Exportables",
      isHidden: (isSoloLectura || isProveedor || isTesoreria),
      childItems: [
        {
          id: 81,
          icon: "mdi mdi-file-excel",
          label: "Publicaciones",
          goToPath: "/Exportables/Publicaciones"
        },
        {
          id: 82,
          icon: "mdi mdi-file-excel",
          label: "Órdenes",
          goToPath: "/Exportables/Ordenes"
        },
        {
          id: 83,
          icon: "mdi mdi-file-excel",
          label: "Novedades",
          isHidden: (!isCategory && !isAdminMod),
          goToPath: "/Exportables/Novedades"
        },
        {
          id: 84,
          icon: "mdi mdi-file-excel",
          label: "Liquidaciones",
          isHidden: !canSeeLiquidaciones,
          goToPath: "/Exportables/Liquidaciones"
        }
      ]
    },
    {
      id: 90,
      icon: "mdi mdi-bank",
      label: "Liquidaciones",
      isHidden: !canSeeLiquidaciones,
      childItems: [
        {
          id: 91,
          icon: "mdi mdi-bullhorn",
          label: "Adm. Novedades",
          goToPath: "/Novedades"
        },
        {
          id: 92,
          icon: "mdi mdi-receipt",
          label: "Adm. Liquidacion",
          goToPath: "/Liquidaciones"
        },
        {
          id: 93,
          icon: "mdi mdi-note-plus-outline",
          label: "Gestion de conceptos",
          goToPath: "/Conceptos"
        },
        {
          id: 94,
          icon: "mdi mdi-file-excel",
          label: "Configuración Fee Logístico",
          goToPath: "/Liquidaciones/FeeLogistico"
        },
        {
          id: 95,
          icon: "mdi mdi-file-pdf-box",
          label: "Comprobantes",
          goToPath: "/Liquidaciones/Comprobantes"
        },
        {
          id: 96,
          icon: "mdi mdi-source-branch",
          label: "Automatizacion",
          goToPath: "/Liquidaciones/Pipelines"
        },
        {
          id: 99,
          icon: "sl-icon-docs",
          label: "Auditoria",
          isHidden: !(isContaduria || idSeller === 1),
          goToPath: "/Liquidaciones/Auditoria"
        }
      ]
    },
    {
      id: 97,
      icon: "mdi mdi-chart-line",
      label: "Generar previsión",
      isHidden: !canSeeLiquidaciones,
      goToPath: "/Prevision"
    },
    {
      id: 100,
      icon: "mdi mdi-bank",
      label: "Detalle Liquidacion",
      isHidden: true,
      childItems: [
        {
          id: 101,
          icon: "mdi mdi-receipt",
          label: "Adm. Liquidacion",
          goToPath: "/Liquidaciones"
        },
        {
          id: 102,
          icon: "mdi mdi-file-pdf-box",
          label: "Comprobantes",
          goToPath: "/Liquidaciones/Comprobantes"
        },
        {
          id: 103,
          icon: "mdi mdi-source-branch",
          label: "Automatizacion",
          goToPath: "/Liquidaciones/Pipelines"
        },
      ]
    },
    {
      id: 120,
      icon: "mdi mdi-image-multiple",
      label: "Banners",
      isHidden: (!isCategory && !isAdminMod),
      goToPath: "/Banners"
    },
    
  ]

  const filterByUserType = (items) => {
    return items
      .filter((item) => !item.isHidden)
      .map((item) => {
        if (item.childItems && item.childItems.length > 0) {
          item.childItems = filterByUserType(item.childItems);
        }
        return item;
      });
  };

  if (forPermissions) {
    return cloneItemsWithoutHiddenFlag(sidebarItems);
  }

  return filterByUserType(sidebarItems);
};

export const getSidebarPermissionItems = (userType = {}) => {
  return getSidebarItems(userType, 1, undefined, { forPermissions: true });
};

export const setHiddenItemsId = (itemsId) => (dispatch) => {
  dispatch({
    type: SIDEBAR.SET_HIDDEN_ITEMS,
    payload: itemsId
  });
};

export const filterByHiddenItemsId = (sidebarItems, hiddenItemsId) => {
  return sidebarItems
    .filter((item) => !hiddenItemsId?.includes(item.id))
    .map((item) => {
      if (item.childItems && item.childItems.length > 0) {
        item.childItems = filterByHiddenItemsId(item.childItems, hiddenItemsId);
      }
      return item;
    });
};

export const clearFilters = (userType, idSeller) => (dispatch) => {
  localStorage.removeItem("pagina");

  dispatch(
    limpiarFiltros({
      dashboard: true,
      ordenes: true,
      sellers: true,
      publicaciones: true,
      rebates: true,
      liquidaciones: true,
      grupoPlanes: true,
    })
  )

  dispatch(
    setFiltroOrdenes({})
  );

  dispatch(
    setFiltroSeller([])
  );

  dispatch(
    resetSellers([])
  );

  dispatch(
    resetFiltroLiquidaciones([])
  );

  dispatch(
    resetPublicaciones([])
  );

  dispatch(
    resetListPublicaciones([])
  );

  dispatch(
    setFiltroGrupoPlanes([])
  );

  dispatch(
    setFiltroTipoPublicaciones([])
  );

  dispatch(
    resetTipoPublicaciones([])
  );

  dispatch(
    resetGrupoPlanes([])
  );

  dispatch(
    resetOrdenes([])
  );

  dispatch(
    resetFiltroUsuario([])
  )

  dispatch(
    resetRebates([])
  );

  setTiposGrupoPlanes([]);
  setPlanesDesdeBusqueda([]);
  seModificaronImagenes(false);
  setFiltroPublicacion({ idSeller: userType.isCategory || userType.isAdminMod ? null : idSeller });
};
